// GENERATED FILE - DO NOT MODIFY
export enum CreationSource {
    Unknown = 0,
    Maestro = 1,
    Mobile = 2,
}

export let nameof = "CreationSource";
